import { render, staticRenderFns } from "./SubNavItem.vue?vue&type=template&id=1cdd06af"
import script from "./SubNavItem.vue?vue&type=script&lang=js"
export * from "./SubNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports